import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AboutEntryImpl} from '../../models/aboutEntry';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {CollaboratorCard} from '../../models/collaboratorCard';
import {ScholarEntry} from '../../models/scholarEntry';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AboutComponent implements OnInit {

  supportersImgList: string[] = ['anii-logo.jpg', 'mirtrans.png', 'seg.png', 'emobility.png', 'sadar.png', 'moves.png', 'itpc.png',
    'ancap.png', 'ute.jpg', 'mtop.png'];

  collaboratorCardList: CollaboratorCard[] = [
    new CollaboratorCard('walther.png', 'Dr. Walther Ploos van Amstel', 'AUAS Faculty of Technology', 'auas.png'),
    new CollaboratorCard('marc.jpg', 'Dr. Marc Torrell y su equipo', 'Investigadores del Instituto de Investigación en Energía de Cataluña', 'irec.jpg'),
    new CollaboratorCard('andres.jpg', 'Dr. Ing. Andrés Romero', 'Instituto de Energía Eléctrica de la Universidad Nacional de San Juan-CONICET', 'conicet.jpg'),
    new CollaboratorCard('marcio.jpg', 'Dr. Marcio D’ Agosto', 'Coordinador del Centro de transporte de carga del PET-COPPE de FRJ', 'coppe.png'),
    new CollaboratorCard('alvaro-marchant.jpg', 'Ing. Alvaro Marchant', 'Jefe de Innovación en el Desarrollo de la Distribución en CCU Chile', 'ccu.png')
  ];

  aboutEntryList: AboutEntryImpl[] = [
    new AboutEntryImpl(
      'Contexto: importancia de la temática',
      `
      <p>
      Uruguay viene, desde hace un tiempo, desarrollando políticas que apuntan a una soberanía energética en el sector transporte, trayendo
      consigo una reducción de las emisiones a la atmósfera de gases de efecto invernadero (GEI) producto de la combustión de combustibles
      fósiles. En este sentido, el país se encuentra explorando la viabilidad del transporte eléctrico. Ya existen en el país varios pilotos
      y estudios en marcha acerca de la introducción de taxis, vehículos utilitarios livianos y ómnibus eléctricos, todos ellos con muy
      buenos resultados y buen potencial a futuro. No obstante, hasta el momento no se han realizado estudios en el país acerca de los
      desafíos de introducir camiones de carga eléctricos (con un peso > 2 Ton) funcionando con batería eléctrica o hidrógeno.
      </p>
      <p>
      El sector transporte de carga es clave para la productividad del país y es, además, importante dentro del total del transporte en
      materia de consumo de combustible y generación de emisiones de GEI. Partiendo del estado actual del transporte eléctrico de carga a
      nivel internacional, y utilizando una serie de herramientas cualitativas y cuantitativas, este proyecto tiene como objetivo evaluar
      los principales desafíos, facilitadores, y oportunidades (en términos de costo de vida, emisiones, e infraestructura) que la
      introducción del vehículo eléctrico de carga (a batería o con pila de combustible de hidrógeno) puede tener para el transporte de
      carga del Uruguay. Dicho estudio será realizado en los distintos segmentos de carga (liviano, mediano y pesado) y por su sector de
      actividad. Este es vital para generar información científica confiable a nivel país que permita la generación de políticas públicas
      que fomenten la penetración de este tipo de tecnologías que son ya una realidad a nivel mundial y que cobrarán mayor relevancia en el
      mediano y largo plazo, de forma de lograr un transporte de carga sustentable.
      </p>
      <p>
      Uruguay se presenta como un país con las condiciones ideales para el desarrollo de la movilidad eléctrica dada la disposición de su
      matriz eléctrica, su dependencia actual del precio del petróleo para el combustible y las cortas distancias que existen dentro del
      país, lo cual merma el miedo frente a las autonomías de los vehículos eléctricos. La energía renovable representó el 96% de la energía
      total generada en el año 2018. Además, desde el año 2013 la energía generada ha sido mayor a la demandada. Este exceso se encuentra
      entre el 5-9% de la energía total y es generalmente exportado a los países vecinos a precios bajos. Este exceso de energía que tiene
      el país podría ser explotado si hubiera un incremento en la demanda de energía eléctrica y este incremento podría venir de los
      vehículos eléctricos.
      </p>`
    ),
    new AboutEntryImpl(
      'Objetivo y alcance del proyecto',
      `
      <p>
      Considerando las características específicas del sector transporte de carga, y el estado tecnológico y comercialde los vehículos de
      carga eléctricos a batería o con pila de combustible de hidrógeno, el objetivo principal deeste proyecto consiste en evaluar los
      principales desafíos, facilitadores y oportunidades que la introducción delvehículo eléctrico de carga (camiones eléctricos)
      puede tener para el transporte de carga del Uruguay, analizando en sus distintos segmentos de carga, sectores de
      actividad y tipo de operación. Para ello, seránecesario entender la situación internacional de la temática, su grado de
      desarrollo, así como las perspectivas delos distintos actores involucrados, de manera de analizar cómo podría cada uno de ellos
      acelerar la introducciónde esta tecnología en el país. El proyecto pretende mediante metodologías cuantitativas y cualitativas,
      generarinformación confiable para promover la tecnología eléctrica en los dadores de carga y transportistas, así comopromover una base
      para la generación de políticas públicas eficientes para este sector.
      </p>
      <p>El proyecto consiste en ocho actividades principales:</p>
      <ul class="grid-list">
      <li>
      <span class="round-img-container"><img class="shift-right" src="assets/img/investigation.png" alt="investigation"></span>
      <p>Revisión del estado actual de lastecnologías existentes a nivel mundial para los distintos segmentos de carga</p>
      </li>
      <li>
      <span class="round-img-container"><img src="assets/img/barrier.png" alt="barrier"></span>
      <p>Diagnóstico sobre barreras y oportunidades percibidas por el sector</p>
      </li>
      <li>
      <span class="round-img-container"><img src="assets/img/budget.png" alt="budget"></span>
      <p>Construcción de paramétrica para la estimación del costo total de propiedad (TCP) de los camiones eléctricos</p>
      </li>
      <li>
      <span class="round-img-container"><img class="shift-left" src="assets/img/analysis.png" alt="analysis"></span>
      <p>Análisis de sensibilidad de la paramétrica de TCO para cuantificar el impacto de la variación de distintos factores</p>
      </li>
      <li>
      <span class="round-img-container"><img src="assets/img/emissions-levels.png" alt="emission levels"></span>
      <p>Análisis comparativo de las emisiones de gases de efecto invernadero (GEI) totales de los camiones eléctricos</p>
      </li>
      <li>
      <span class="round-img-container"><img src="assets/img/company.png" alt="company"></span>
      <p>Desafíos para el sector empresarial para analizar la infraestructura e inversiones necesarias para viabilizar un cambio de flota</p>
      </li>
      <li>
      <span class="round-img-container"><img src="assets/img/delivery-truck.png" alt="delivery truck"></span>
      <p>Monitorear el funcionamiento de un camión eléctrico (rendimiento, costos/beneficios, etc.)</p>
      </li>
      <li>
      <span class="round-img-container"><img src="assets/img/promotion.png" alt="promotion"></span>
      <p>Difusión extensiva en el sector transporte de carga sobre los resultados obtenidos en el proyecto</p>
      </li>
      </ul>
      `),
    new AboutEntryImpl(
      'Impactos esperados',
      `
<ul class="support-entry-list">
<li>Favorecer la introducción de la tecnología eléctrica en el transporte de carga</li>
<li>Disminución de la huella generada por el transporte de carga</li>
<li>Generación de información relevante para la toma de decisiones para nuevos pilotos o
introducción de vehículos eléctricos de carga por parte del sector empresarial</li>
<li>Información para la evaluación de posibles políticas públicas</li>
<li>Fomentar la producción y consumo de hidrógeno verde en Uruguay</li>
</ul>
      `
    ),
    new AboutEntryImpl(
      'Apoyos y colaboraciones',
      `
<div class="img-flex-container">` + this.createCollaboratorsImgList() + `
<!--<img src="/assets/img/{{img}}" alt="{{img}}">-->
<!-- <img src="/assets/img/anii-logo.jpg" alt="anii-logo">-->
<!-- <img src="/assets/img/mirtrans.png" alt="mirtrans.png">-->
<!-- <img src="/assets/img/seg.png" alt="seg">-->
<!-- <img src="/assets/img/emobility.png" alt="emobility">-->
</div>
<h6 class="bold-title">Colaboradores</h6>
<div class="collaborators-list">` + this.createAllCollaboratorCards() + `</div>
`
    ),
    new AboutEntryImpl(
      'Eventos',
      `
<h6 class="blue-title">Kick off del proyecto</h6>
<p>Presentación y lanzamiento del proyecto con la exposición de Walther Ploos van Amstel, experto en logística urbana de cero emisiones.</p>
<ul class="pdf-list">
<li><a href="assets/files/Keynote speaker Walther Ploos van Amstel.pdf" download>Keynote speaker Walther Ploos van Amstel</a></li>
<li><a href="assets/files/Kick_Off_Proyecto.pdf" download>Kick Off Proyecto</a></li>
</ul>

<h6 class="blue-title">Seminario “Uruguay apuesta por los camiones eléctricos: experiencias nacionales y regionales”</h6>
<p>Evento que tuvo lugar el martes 13 de julio, donde se expusieron los resultados del “Informe técnico sobre Barreras y Oportunida desde la
inserción del transporte de carga eléctrico en Uruguay” y posteriormente participaron ocho oradores: Santiago Guelfi, director de SADAR;
Guillermo Novelli, director ejecutivo de Mobility Uruguay; Brian Lempert, director del Grupo Fiancar; Sebastián Baccino, director de GlobalEV;
Marcio D’Agosto, profesor de la Universidad Federal de Río de Janeiro (Brasil); André Luiz Ferri, especialista en logística en AMBEV (Brasil);
Carlos Serrano, Jefe de producto de Renting (Colombia) y Álvaro Marchant, Jefe de Innovación en CCU (Chile).</p>
<a class="info-link-shifted" target="_blank"
href="https://umontevideo-my.sharepoint.com/:f:/g/personal/mcavallieri_correo_um_edu_uy/EoB-AWYGIodFua5UlLtnieYBwX15eZRmZUgYPVDtiXNrvg?e=By0Z24">
Presentaciones del seminario</a>

<h6 class="blue-title">Expocarga 2021: Presentación en Portal Movilidad 4.0</h6>
<p>Evento que tuvo lugar desde el 2 al 5 de diciembre en el Convention & Exhibition Center de Punta del Este. Se presentó en el forode
Movilidad los resultados obtenidos del monitoreo de dos camiones eléctricos y enseñaron la herramienta TCO (Total Costo OfOwnership) para
evaluar la inversión en camiones eléctricos. También se realizaron pruebas en vivo de la herramienta TCO paraque los presentes pudieran
evaluar los costos de adquirir un camión eléctrico en comparación con un camión convencional a diésel.
</p>
<p>
El CINOI contó con un stand en el hall principal donde además presentó material de difusión sobre otros proyectos.
</p>
<a class="info-link-shifted" href="assets/files/Presentación Foro Movilidad.pdf" download>
Presentación Foro Movilidad
</a>

<h6 class="blue-title">Encuentro PLSU (Programa de Logística Sustentable Uruguay)</h6>
<p>El 14 de diciembre se realizó un encuentro con los participantes del PLSU, un proyecto liderado por el CINOI que buscabrindarcapacitación
a empresas y contratistas para lograr una mejora en el transporte de carga en Uruguay, con un enfoque sustentableque tienda a disminuir sus
emisiones.
</p>
<p>En el evento, el equipo del proyecto presentó los resultados obtenidos del monitoreo de dos camiones eléctricos y una comparaciónde
costos con camiones del mercado uruguayo, utilizando la herramienta TCO (Total Costo Of Ownership).
</p>
<a class="info-link-shifted" href="assets/files/Presentación PLSU.pdf" download>Presentación en PLSU</a>
      `
    ),
    new AboutEntryImpl(
      'Documentos',
      `
<ul class="pdf-list">
<li><a href="assets/files/Informe estado del arte.pdf" download>Informe estado del arte</a></li>
<li><a href="assets/files/Informe de barreras y oportunidades.pdf" download>Informe de barreras y oportunidades</a></li>
<li><a href="assets/files/Estructura metodológica para herramienta de calculo de costo total de propiedad.pdf" download>Estructura metodológica para herramienta de cálculo de costo total de propiedad</a></li>
<li><a href="assets/files/Emisiones de contaminantes.pdf" download>Emisiones de contaminantes</a></li>
<li><a href="assets/files/Desafíos para el sector empresarial - preguntas y respuestas.pdf" download>Desafíos para el sector empresarial - preguntas y respuestas</a></li>
<li><a href="assets/files/Reporte Monitoreo de Camiones Eléctricos.pdf" download>Reporte Monitoreo de Camiones Eléctricos</a></li>
</ul>
`
    ),
    new AboutEntryImpl(
      'Investigadores',
      `
<ul class="scholar-list">
<li class="group-1">` + this.createScholarEntry(new ScholarEntry('Dr. Ing. Martín Tanco', 'Decano FIUM', 'Responsable técnico-científico', 'martin-tanco.png')) + `</li>
<li class="group-1">` + this.createScholarEntry(new ScholarEntry('Dr. Ing. Daniel Jurburg', 'Director CINOI', 'Co-responsable técnico-científico', 'daniel-jurburg.jpg')) + `</li>
<li class="group-1">` + this.createScholarEntry(new ScholarEntry('Martín Levy', '5to año Ingeniería Industrial', 'Investigador', 'martin-levy.jpg')) + `</li>
<li class="group-1">` + this.createScholarEntry(new ScholarEntry('Sebastián Rossi', '5to año Ingeniería Industrial', 'Investigador', 'seba-rossi.jfif')) + `</li>
<li class="group-1">` + this.createScholarEntry(new ScholarEntry('María Sol Cavallieri', '5to año Ingeniería Industrial', 'Investigador', 'sol-cavallieri.jfif')) + `</li>
<li class="group-2">` + this.createScholarEntry(new ScholarEntry('Ing. MBA Mariní Camacho', 'Project Manager VERNE-ANCAP', 'Maestrando', 'marini-camacho.jfif')) + `</li>
<li class="group-2">` + this.createScholarEntry(new ScholarEntry('Ing. Nicolás van der Maesen', 'Jefe de Ingeniería MTOP', 'Maestrando', 'nicolas-van-der-maesen.jfif')) + `</li>
<li class="group-2">` + this.createScholarEntry(new ScholarEntry('Anl. Econ. Carolina Romero', 'Intendencia de Montevideo', 'Investigador', 'carolina-romero.jfif')) + `</li>
</ul>
`
    )];


  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
  }

  private createImgTag(image: string): string {
    return `<img src="assets/img/${image}" alt="${image}">`;
  }

  createCollaboratorsImgList(): string {
    let collaboratorsImgList = '';
    this.supportersImgList.forEach(img => collaboratorsImgList += this.createImgTag(img) + '\n');
    return collaboratorsImgList;
  }

  private createCollaboratorCard(profileImg: string, name: string, brandName: string, brandImg: string): string {
    return `
<div class="collaborator-card">
<img class="profile-img" src="assets/img/${profileImg}" alt="${name}">
<p class="card-name">${name}</p>
<p>${brandName}</p>
<img class="brand-img" src="assets/img/${brandImg}" alt="${brandImg}">
</div>`;
  }

  createAllCollaboratorCards(): string {
    let allCollaborators = '';
    this.collaboratorCardList.forEach(collaboratorCard => {
      allCollaborators += this.createCollaboratorCard(
        collaboratorCard.profileImg,
        collaboratorCard.name,
        collaboratorCard.brandName,
        collaboratorCard.brandImg);
    });
    return allCollaborators;
  }

  private createScholarEntry({name, title, role, imgUrl}: ScholarEntry): string {
    return `
    <img class="icon-img" src="assets/img/${imgUrl}" alt="${name}">
    <div>
    <p class="scholar-name">${name}</p>
    <p class="scholar-title">${title}</p>
    <p class="scholar-role">${role}</p>
    </div>
    `;
  }

  safeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  changeEntry(currentAboutEntry: AboutEntryImpl): void {
    currentAboutEntry.status = !currentAboutEntry.status;

    for (const aboutEntry of this.aboutEntryList) {
      if (aboutEntry !== currentAboutEntry) {
        aboutEntry.status = false;
      }
    }
  }

}
